var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState, useEffect } from 'react';
import { Select as AntdSelect } from 'antd';
import { SelectDropdown } from './SelectDropdown';
var Option = AntdSelect.Option;
export var Select = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, mode = _a.mode, _c = _a.onSelectChange, onSelectChange = _c === void 0 ? null : _c, value = _a.value, _d = _a.dropdownRender, dropdownRenderProp = _d === void 0 ? null : _d, props = __rest(_a, ["options", "mode", "onSelectChange", "value", "dropdownRender"]);
    var _e = useState(value), currentValue = _e[0], setCurrentValue = _e[1];
    useEffect(function () {
        setCurrentValue(value);
    }, [value]);
    var handleChange = useCallback(function (newValue) {
        setCurrentValue(newValue);
        if (onSelectChange) {
            onSelectChange(newValue);
        }
    }, [onSelectChange]);
    var handleSelectAll = useCallback(function () {
        var newValue = options.map(function (_a) {
            var key = _a.key;
            return key;
        });
        setCurrentValue(newValue);
        if (onSelectChange) {
            onSelectChange(newValue);
        }
    }, [onSelectChange, options]);
    var handleReset = useCallback(function () {
        setCurrentValue([]);
        if (onSelectChange) {
            onSelectChange([]);
        }
    }, [onSelectChange]);
    var dropdownRender = useCallback(function (menu) {
        return mode ? (React.createElement(SelectDropdown, { menu: menu, reset: handleReset, selectAll: handleSelectAll })) : (menu);
    }, [handleReset, handleSelectAll, mode]);
    return (React.createElement(AntdSelect, __assign({}, props, { value: currentValue, mode: mode, onChange: handleChange, optionFilterProp: "title", filterOption: true, dropdownRender: dropdownRenderProp || dropdownRender }), options.map(function (_a) {
        var key = _a.key, optionValue = _a.value, component = _a.component;
        return (React.createElement(Option, { key: key, value: key, title: optionValue }, component || optionValue));
    })));
};
//# sourceMappingURL=Component.js.map